import Content from '../components/home/Content'

const Favorites = () => <Content fav={true}/>

export default Favorites